import { canAddCommentsFromOperations } from '@confluence/entity-operations/entry-points/canAddCommentsFromOperations.ts';

import { useEditorAddCommentPermissionFragment } from './useEditorAddCommentPermissionFragment.ts';

/**
 * Whether the user can add comments to the editor document, from EditorContentUnifiedQuery.
 * canAddComments is undefined when the editor does not provide its document, so the caller
 * fetches the permission.
 */
export const useEditorCanAddComments = (
	contentId: string | undefined,
): { canAddComments: boolean | undefined; error: Error | undefined } => {
	const { isProvided, loading, data, error } = useEditorAddCommentPermissionFragment({
		contentId,
	});
	if (!isProvided || loading) {
		return { canAddComments: undefined, error: undefined };
	}
	// A field error hides commenting, as a failed fetch does.
	return { canAddComments: canAddCommentsFromOperations(data?.operations), error };
};
